import React, { useId } from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export function Input({
  label,
  error,
  className = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || useId();
  return <div className="w-full" data-id="element-196">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-black mb-2" data-id="element-197">
          {label}
        </label>}
      <input id={inputId} className={`
          flex h-12 w-full rounded-none border border-neutral-200 bg-white px-4 py-2 text-base placeholder:text-neutral-400 
          focus:outline-none focus:border-black focus:ring-0 disabled:cursor-not-allowed disabled:opacity-50
          transition-colors duration-200
          ${error ? 'border-red-500 focus:border-red-500' : ''}
          ${className}
        `} {...props} data-id="element-198" />
      {error && <p className="mt-1 text-sm text-red-500" data-id="element-199">{error}</p>}
    </div>;
}